export default __webpack_public_path__ + "static/media/kitchen5.91aaaa65.webp";